import template from './app.html';
import controller from './app.controller.js';

const appComponent = {
  template,
  controller,
  restrict: 'E',
};

export default appComponent;



/** WEBPACK FOOTER **
 ** ./client/app/app.component.js
 **/